import classNames from 'classnames'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'

import ValidationMessage from 'admin/components/common/ValidationMessage'
import Hint from 'components/common/Hint'
import Text from 'components/ui/Text'

interface FormFieldProps {
  control: any
  name: string
  label: string | any
  hint?: string
  maxLength?: number
  validate?: any
  type?: string
  disabled?: boolean
  placeholder?: string
  autoComplete?: string
  autoFocus?: boolean
  TextComponent?: React.ComponentType<any>
  ValidationMessageComponent?: React.ComponentType<any>
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
}

const FormField = forwardRef<HTMLInputElement, FormFieldProps>((props, ref) => {
  const {
    control,
    name,
    label,
    hint,
    maxLength,
    validate,
    type = 'text',
    disabled,
    placeholder,
    autoComplete,
    autoFocus,
    TextComponent = Text,
    ValidationMessageComponent = ValidationMessage,
    onBlur
  } = props

  return (
    <Controller
    control={control}
    name={name}
    rules={{ validate }}
    render={({ field, fieldState: { error } }) => (
      <div>
        <label htmlFor={name}>
          <div className="l-columns">
            <TextComponent>{label}</TextComponent>
            {hint && (
              <Hint
              classNames="l-margin--l l-margin--b"
              tooltipText={<TextComponent>{hint}</TextComponent>}
              />
            )}
          </div>
        </label>
        <input
          ref={ref} 
          disabled={disabled}
          autoComplete={autoComplete}
          className={classNames(error?.type && 'input--invalid', disabled && 'disabled')}
          data-testid={`text_${field.name}`}
          placeholder={placeholder}
          {...field}
          maxLength={maxLength}
          type={type}
          autoFocus={autoFocus}
          onBlur={(e) => {
              field.onBlur()  
              if (onBlur) {  
                onBlur(e)
              }
            }}
        />
        {error && <ValidationMessageComponent error={error.message} />}
      </div>
    )}
  />
  )
});

FormField.displayName = 'FormField';

export default FormField
